import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ReferralLanding from "./pages/ReferralLanding";
import Maintenance from "./components/Maintenance";
import { useMaintenance } from "./hooks/useMaintenance";
import "./styles/main.scss";


export default function App(): JSX.Element {
    const { maintenanceEnabled, maintenanceMessage } = useMaintenance();

    // Show maintenance page if enabled
    if (maintenanceEnabled) {
        return <Maintenance message={maintenanceMessage} />;
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/landing" element={<ReferralLanding />} />
                <Route path="/ref" element={<ReferralLanding />} />
            </Routes>
        </BrowserRouter>
    );
}